import { shotGallery } from "@/mocks/jiukanliao";
import SectionHeading from "./SectionHeading";

export default function ShotGallery() {
  return (
    <section id="shots" className="relative overflow-hidden py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_10%_100%,#f7dcc0_0%,transparent_45%)]" />
      <div className="relative mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="截图合集 · 考古向"
            title="一张截图，撬动整场舆论"
            desc="9看料 截图合集不只搬运原图，更按时间接好对话、圈出关键词，把带节奏的片段和关键反转摆在一起对照。"
          />
          <a
            href="#shots"
            className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-[#d9431f] px-5 py-2.5 text-[13px] font-semibold text-white transition hover:bg-[#b83516] md:inline-flex"
          >
            <i className="ri-file-copy-2-line" />
            打开截图合集
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {shotGallery.map((s) => (
            <a
              key={s.title}
              href="#shots"
              className="group flex flex-col overflow-hidden rounded-2xl bg-white ring-1 ring-[#eadbc0] transition hover:ring-[#d9b67a]"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-[#231f18]/70 px-2.5 py-1 text-[11px] font-medium text-white backdrop-blur">
                  <i className="ri-image-add-line mr-1" />
                  {s.meta}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-display text-[15px] font-bold leading-snug text-[#231f18]">
                  {s.title}
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-[13px] leading-6 text-[#8a7a5d]">
                  {s.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-[#f0e3ca] pt-3 text-[11px] text-[#a48a5d]">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {s.time}
                  </span>
                  <span className="flex items-center gap-1 text-[#b43a17]">
                    看完整截图
                    <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}